import React, { useCallback, useState } from 'react';
import CommandPalette from 'components/common/CommandPalette';
import { useBuscarRegrasFiscaisNFe } from '../../../../hooks/useNFe';
import { RegraFiscalNFeItem } from '../../../../types/nfe';

interface Props {
  show: boolean;
  onHide: () => void;
  onSelecionar: (regra: RegraFiscalNFeItem) => void;
}

const ModalBuscarRegraFiscalNFe: React.FC<Props> = ({ show, onHide, onSelecionar }) => {
  const [termo, setTermo] = useState('');
  const query = useBuscarRegrasFiscaisNFe(termo, show);

  const handleSearch = useCallback((t: string) => setTermo(t), []);

  const handleSelect = useCallback((regra: RegraFiscalNFeItem) => {
    onSelecionar(regra);
  }, [onSelecionar]);

  return (
    <CommandPalette
      show={show}
      onHide={onHide}
      onSearch={handleSearch}
      items={query.data ?? []}
      isFetching={query.isFetching}
      isSuccess={query.isSuccess}
      onSelect={handleSelect}
      getKey={r => r.id}
      placeholder="Código ou descrição da regra..."
      emptyMessage="Nenhuma regra encontrada"
      renderRow={regra => (
        <>
          <span className="cmd-row__doc">{regra.codigo}</span>
          <span className="cmd-row__name">{regra.descricao}</span>
          <div style={{ display: 'flex', gap: '0.3rem', flexShrink: 0 }}>
            {regra.cfop && (
              <span className="cmd-badge cmd-badge--pj">CFOP {regra.cfop}</span>
            )}
            {(regra.csosn || regra.cst) && (
              <span className="cmd-badge cmd-badge--pf">{regra.csosn ?? regra.cst}</span>
            )}
          </div>
        </>
      )}
    />
  );
};

export default ModalBuscarRegraFiscalNFe;
